import {
  GET_PAYMENTUS_SIGNATURE_PENDING,
  GET_PAYMENTUS_SIGNATURE_FULFILLED,
  GET_PAYMENTUS_SIGNATURE_FAILED,
} from "constants-lib/actionTypes"

const initialState = {
  signatureDetails: {},
  signatureState: ``,
  errorMessage: ``,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENTUS_SIGNATURE_PENDING:
      return {
        ...state,
        signatureState: `pending`,
      }
    case GET_PAYMENTUS_SIGNATURE_FULFILLED:
      return {
        ...state,
        signatureDetails: action.payload,
        signatureState: `fulfilled`,
      }
    case GET_PAYMENTUS_SIGNATURE_FAILED:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
        signatureState: `failed`,
      }

    default:
      return state
  }
}
